// extracted by mini-css-extract-plugin
module.exports = {"root":"v_bx","filled":"v_b5","input-area":"v_b6","inputArea":"v_b6","label":"v_b7"};